import { DrawAPI } from '../../../api/bussched/DrawAPI';

export class DrawCommand {
    list(networkId, successCallback, errorCallback) {
        const apiResult = DrawAPI.list(networkId);
        apiResult.then((result) => {
            if ("function" === typeof successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a ler os dados");
            }
        });
    }

    generateLineSched(layout, form, successCallback, errorCallback) {
        const apiResult = DrawAPI.generateLineSched(layout.id, form);
        apiResult.then((result) => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos gerados com sucesso.", result);
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração dos documentos.");
            }
        });
    }

    generateBusSched(layout, form, successCallback, errorCallback) {
        const apiResult = DrawAPI.generateBusSched(layout.id, form);
        apiResult.then((result) => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos gerados com sucesso.", result);
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração dos documentos.");
            }
        });
    }

    generateCarrisSched(parameters, successCallback, errorCallback) {
        const apiResult = DrawAPI.generateCarrisSched(parameters);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos gerados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração dos documentos.");
            }
        });
    }

    getMissingConfigsTml(filter, successCallback, errorCallback) {
        const apiResult = DrawAPI.getMissingConfigsTml(filter);
        apiResult.then((result) => {
            if ("function" === typeof successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((error) => {
            if ("function" === typeof errorCallback) {
                errorCallback(error.message);
            }
        });
    }

    regenerateTml(filter, successCallback, errorCallback) {
        const apiResult = DrawAPI.regenerateTml(filter);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos gerados com sucesso.");
            }
        }).catch((error) => {
            if ("function" === typeof errorCallback) {
                errorCallback(error.message);
            }
        });
    }

    generateTmlBusSched(parameters, successCallback, errorCallback) {
        const apiResult = DrawAPI.generateTmlBusSched(parameters);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos gerados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração dos documentos.");
            }
        });
    }

    generateTmlStopSched(parameters, successCallback, errorCallback) {
        const apiResult = DrawAPI.generateTmlStopSched(parameters);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos gerados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração dos documentos.");
            }
        });
    }

    generateViaPortoLineSched(parameters, successCallback, errorCallback){
        const apiResult = DrawAPI.generateViaPortoLineSched(parameters);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos gerados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração dos documentos.");
            }
        });
    }

    fixed(fileName, successCallback, errorCallback) {
        const apiResult = DrawAPI.fixed(fileName);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documento marcado como afixado com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a marcar o documento como afixado.");
            }
        });
    }

    unfixed(fileName, successCallback, errorCallback) {
        const apiResult = DrawAPI.unfixed(fileName);
        apiResult.then(() => {
            if (undefined !== successCallback) {
                successCallback("Documento marcado como não afixado com sucesso.");
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a marcar o documento como não afixado.");
            }
        });
    }

    generateSmtucLineSched(parameters, successCallback, errorCallback) {
        const apiResult = DrawAPI.generateSmtucLineSched(parameters);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documento gerado com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração do documento.");
            }
        });
    }

    generateSmtucPocketSched(parameters, successCallback, errorCallback) {
        const apiResult = DrawAPI.generateSmtucPocketSched(parameters);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documento gerado com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro durante a geração do documento.");
            }
        });
    }

    delete(fileName, successCallback, errorCallback) {
        const apiResult = DrawAPI.delete(fileName);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos eliminados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a eliminar os documentos.");
            }
        });
    }

    deleteMultiple(filesName, successCallback, errorCallback) {
        const apiResult = DrawAPI.deleteMultiple(filesName);
        apiResult.then(() => {
            if ("function" === typeof successCallback) {
                successCallback("Documentos eliminados com sucesso.");
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a eliminar os documentos.");
            }
        });
    }

    updateLinesEx(codes, successCallback, errorCallback) {
        const apiResult = DrawAPI.updateLinesEx(codes);
        apiResult.then((result) => {
            if ("function" === typeof successCallback) {
                successCallback(result);
            }
        }).catch(() => {
            if ("function" === typeof errorCallback) {
                errorCallback("Ocorreu um erro a atualizar as linhas.");
            }
        });
    }
}
